<template>
  <v-layout column>
    <v-col>
      <span class="headline text-left mb-5 ml-5"
        ><v-icon class="mr-1">mdi-account-group</v-icon> Groups</span
      >

      <v-btn
        style="float: right;"
        color="primary"
        @click="createGroupDialog = true"
        >Create</v-btn
      >
      <v-divider class="mt-3 mb-5"></v-divider>

      <v-text-field
        solo
        label="Search for a group"
        v-if="groups.length > 5"
      ></v-text-field>

      <v-row>
        <v-card
          class="ml-3 mt-2"
          outlined
          width="320"
          v-for="group in groups"
          :key="group.id"
        >
          <v-card-title color="primary">
            <router-link
              :to="{ name: 'group', params: { id: group.id } }"
              style="text-decoration: none;"
              >{{ group.name }}</router-link
            >
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text>Members: {{ group.members.length }} </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-row>
    </v-col>

    <v-dialog width="500" persistent v-model="createGroupDialog">
      <v-card>
        <v-card-title>Create a group</v-card-title>
        <v-divider></v-divider>

        <v-card-text class="mt-3">
          <v-text-field label="Group name" v-model="groupName"></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="createGroupDialog = false">close</v-btn>
          <v-btn color="primary" @click="create">create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    createGroupDialog: false,
    createGroupLoading: false,
    groupName: null,
  }),

  computed: {
    ...mapGetters({
      signedIn: "user/signedIn",
      groups: "group/groups",
    }),
  },

  methods: {
    create() {
      this.createGroupLoading = true;

      this.$store
        .dispatch("group/create", {
          payload: {
            name: this.groupName,
          },
        })
        .finally(() => {
          this.createGroupLoading = false;
          this.createGroupDialog = false;
        });
    },
  },

  watch: {
    async signedIn(v) {
      if (v) {
        try {
          await this.$store.dispatch("group/fetch");
        } catch (e) {
          this.$store.dispatch("error/handle", e);
        }
      }
    },
  },

  async mounted() {
    if (this.signedIn) {
      try {
        await this.$store.dispatch("group/fetch");
      } catch (e) {
        this.$store.dispatch("error/handle", e);
      }
    }
  },
};
</script>
